<template>
    <div class="block-promo" id="block-promo">
        <div class="main-wrap">
            <div class="block-promo__content">
                <p class="block-promo__title">3-6</p>
                <p class="block-promo__text">
                    Первый кризис (да, уже), адаптация к детскому саду, самостоятельность и упрямство. Наравне с этим энциклопедические познания и подготовка к школе.
                </p>
                <BlockParallax class="block-promo__icon block-promo--cube" speed="2" direction="left">
                    <img src="@/assets/images/icons/cube.png">
                </BlockParallax>
                <BlockParallax class="block-promo__icon block-promo--icon-desktop block-promo--cube-two " speed="2">
                    <img src="@/assets/images/icons/cube.png">
                </BlockParallax>
                <BlockParallax class="block-promo__icon block-promo--lego-green" speed="5" direction="left">
                    <img src="@/assets/images/icons/lego-green.png">
                </BlockParallax>
                <BlockParallax class="block-promo__icon block-promo--icon-desktop block-promo--lego-green-two" speed="3">
                    <img src="@/assets/images/icons/lego-green.png">
                </BlockParallax>
                <BlockParallax class="block-promo__icon block-promo--lego-red" speed="8" direction="left">
                    <img src="@/assets/images/icons/lego-red.png">
                </BlockParallax>
                <icon-arrow class="block-promo__arrow" v-scroll-to="'#block-info-two'" />
            </div>
        </div>
        <BlockParallax class="block-promo__icon block-promo--car-one" speed="4" transform="animate3" fixed>
            <img src="@/assets/images/icons/car-1.png">
        </BlockParallax>
        <BlockParallax class="block-promo__icon block-promo--car-two" speed="4" transform="animate4" fixed>
            <img src="@/assets/images/icons/car-2.png">
        </BlockParallax>
    </div>
</template>

<script>
import BlockParallax from '@/components/blocks/parallax'

export default {
    components: {
        BlockParallax
    }
}
</script>


<style scoped lang="stylus">
    .block-promo {
        position relative
        background-color $color-yellow
        overflow hidden
        background-image url('~@/assets/images/icons/line-white-mobile.png') ,
        url('~@/assets/images/icons/car-mobile-1.png')
        background-repeat no-repeat
        background-position bottom 4px left, right top
        background-size 12rem, contain
        +layout-md-and-up() {
            position relative
            background-image url("~@/assets/images/icons/road-1.png") , url('~@/assets/images/icons/line-white-3.png') , url("~@/assets/images/icons/road-2.png") , url("~@/assets/images/icons/line-white-4.png")
            background-position left bottom, left 21px top, right top, right top
            background-size 50rem, 30rem, contain
        }

        &__content {
            position relative
            +layout-md-and-up() {
                display flex
                flex-direction column
                align-items center
                padding-bottom 5rem

            }
        }

        &__title {
            font-size 5.6rem
            color #FFFFFF
            font-weight 900
            letter-spacing 0.61px
            margin 2.7rem 0 0
            padding 0 0 0 5rem

            +layout-sm-and-up() {
                text-align center
                padding 0
            }
            +layout-md-and-up() {
                font-size 8rem
                letter-spacing 0.87px
                margin 12rem 0 0
                padding 0
            }
        }

        &__text {
            box-sizing border-box
            margin 0
            padding 2rem 2rem 13rem 5rem
            font-size 1.5rem
            line-height 1.47
            color $color-text

            +layout-sm-and-up() {
                text-align center
                font-size 1.8rem
                line-height 2.8rem
                letter-spacing 0.19px
            }
            +layout-md-and-up() {
                width 100%
                max-width 63rem
                padding-bottom 0
                padding-top 2.1rem

            }
        }

        &__icon {
            position absolute
            max-width 100%
        }

        &--desktop {
            display none
            +layout-md-and-up() {
                display block
            }
        }

        &--cube {
            top 1rem
            right 0.8rem
            width 6.2rem
            transform rotate(65deg)
            +layout-md-and-up() {
                right -14.2rem
                width 8.2rem
            }
        }

        &--cube-two {
            +layout-md-and-up() {
                width 15.2rem
                left -176px
                top 239px
            }
        }

        &--lego-red {
            left 3.7rem
            bottom 2.2rem
            transform rotate(239deg)
            width 9.2rem
            +layout-md-and-up() {
                left auto
                bottom auto
                top 13.1rem
                right 2.7rem
                width 12.2rem
            }
        }

        &--lego-green {
            left -3.3rem
            top 7.2rem
            transform rotate(-71deg)
            width 9.2rem
            +layout-md-and-up() {
                left -8.3rem
                top 6.2rem
                width 18.2rem
            }

        }

        &--lego-green-two {
            +layout-md-and-up() {
                right -17rem
                bottom 1.4rem
                width 18.2rem
            }

        }

        &__arrow {
            width 2rem
            position absolute
            right 0.6rem
            bottom 2rem
            animation translate 1.5s linear infinite forwards

            +layout-md-and-up() {
                position static
                padding-top 0
                margin-top 2rem
                padding-bottom 8.5rem
                cursor pointer

                &:hover {
                    fill $color-blue
                    cursor pointer
                    animation-play-state paused
                    opacity 0.7
                }
            }
        }

        &--car-one {
            display none
            +layout-md-and-up() {
                display block
                bottom 1.6rem
                left 27.6rem
                transform rotate(-2deg)
            }
        }
        &--car-two {
            display none
            +layout-md-and-up() {
                display block
                bottom 6.6rem
                right 26.8rem
                transform rotate(12deg)
            }
        }
    }

</style>
